import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

import { getCurrentLang } from "@/lib/i18n";

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export function fileUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/api/files/")) return `${BACKEND_URL}${path}`;
    return path;
}

const IMG_WIDTHS = [320, 640, 960, 1280];
/** Optimised WebP rendition of an uploaded image (/api/files/…?w=N). Non-upload URLs are returned as-is. */
export function imgUrl(path, w = 640) {
    const u = fileUrl(path);
    return u && path.startsWith("/api/files/") && /\.(jpe?g|png|webp)$/i.test(path) ? `${u}?w=${w}` : u;
}
export function imgSrcSet(path, max = 1280) {
    if (!path || !path.startsWith("/api/files/") || !/\.(jpe?g|png|webp)$/i.test(path)) return undefined;
    return IMG_WIDTHS.filter((w) => w <= max).map((w) => `${fileUrl(path)}?w=${w} ${w}w`).join(", ");
}

export function formatError(detail) {
    if (detail == null) return "حدث خطأ ما، حاول مرة أخرى.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Language-aware public data: English pages fetch translated fields (cache is split per lang).
api.interceptors.request.use((config) => {
    if (getCurrentLang() !== "ar" && (config.url || "").startsWith("/public/")) {
        config.params = { ...(config.params || {}), lang: getCurrentLang() };
    }
    return config;
});
